module.exports = __webpack_public_path__ + "media/new_goods_refund.fe84895a.wav";